<template>
  <div class="workbench-title">
    {{ title }}
  </div>
</template>
<script>
export default {
  name: "workbench-title",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
